    <div class="transparent-black-background" *ngIf="maskActive"></div>
    